import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-brand-navy" data-id="element-173" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-174" data-mp="3b143x9u7tf3q">
        <h2 id="testimonios" className="font-display text-[1.75rem] leading-[1.05] text-white sm:text-5xl" data-id="element-175" data-mp="36yzeyoepp6nf">
          Lo que dicen <span className="text-brand-yellow" data-id="element-176" data-mp="31z3citlnxn9z">quienes ya empezaron</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-177" data-mp="2x1uquj1b313z">
          De no saber qué actividades ofrecer a descubrir nuevas formas de
          aprender jugando.
        </p>
        <p className="mx-auto mt-1 max-w-xl text-[11px] italic leading-snug text-white/60" data-id="element-178" data-mp="v9oqhp5txq53">
          Los siguientes textos son ejemplos ilustrativos del tipo de
          experiencia que busca ofrecer el producto; deben reemplazarse por
          testimonios reales antes de publicar.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-179" data-mp="m5b3blltfogr">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-brand-yellow bg-white p-2.5 text-left text-brand-navy ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-180" data-mp="78k53fnvoisq" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-181" data-mp="14ur6kgovxv0v">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={13} className="fill-brand-gold text-brand-gold" data-id="element-182" data-mp="v5g1d554dai9" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-183" data-mp="1nlqt7b8wqsqz">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-184" data-mp="1xgphl4weee4w">
                <p className="font-sub text-sm font-bold text-brand-blue" data-id="element-185" data-mp="1siwe4jmhby8b">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-brand-muted" data-id="element-186" data-mp="1ogjbw56xyiga">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-187" data-mp="1ejoa9dfdg1xs">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
        <p className="mt-2.5 text-xs font-semibold text-white/80" data-id="element-188" data-mp="19rdbwf0a4o7c">
          Acceso Inmediato • Garantía de 7 Días
        </p>
      </div>
    </section>;
}